import React, { useMemo, useEffect, useState } from "react"
import { Container, CardBody, Card } from "reactstrap"
import practice_logo from "../../assets/images/users/profile.png"
import Breadcrumb from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"
import * as XLSX from "xlsx"

const EmployeeDesignationReport = () => {
  const [table_data, settable_data] = useState([])
  const [clientTypes, setclientTypes] = useState([])
  const [loading, setLoading] = useState(false)
  const [clientTypeId, setClientTypeId] = useState(undefined)

  const fetchData = async clientTypeId => {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(
        `/reports/employee-designation/report${clientTypeId ? `?clientTypeId=${clientTypeId}` : ''}?`
      )

      if (response.data.success) {
        settable_data(response.data.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const fetchClientTypes = async () => {
    try {
      const response = await axiosbaseurl.get(`/client-type/active`)
      if (response.data.success) {
        setclientTypes(response.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    (async () => {
      await fetchData()
      await fetchClientTypes()
    })()
  }, [])

  const handleClientTypeChange = e => {
    const selectedId = e.target.value === "" ? undefined : e.target.value
    setClientTypeId(selectedId)
    fetchData(selectedId)
  }

  const exportToExcel = () => {
    const exportData = table_data.map(item => ({
      "Employee Name": item.employeeName,
      "Client Manager": item.clientManager,
      "Production Manager": item.productionManager,
      Assistant: item.assistant,
      Administrator: item.administrator,
    }))

    const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, `Designation Report`)

    const maxWidths = Object.keys(exportData[0] || {}).map(key => ({
      wch: Math.max(
        key.length,
        ...exportData.map(item => String(item[key]).length)
      ),
    }))
    worksheet["!cols"] = maxWidths

    XLSX.writeFileXLSX(
      workbook,
      `Employee_Designation_Report_${moment().format(
        "DD_MM_YYYY_hh_mm_ss"
      )}.xlsx`
    )
  }

  document.title = "Employee Designation Report | Peacock Accountants Limited"

  return (
    <>
      {loading && <Loader />}

      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb
            title={"Dashboard"}
            breadcrumbItem={"Employee Designation Report"}
          />

          <Card className="px-0 mx-0">
            <CardBody>
              <TableComponent
                table_data={table_data}
                exportToExcel={exportToExcel}
                clientTypes={clientTypes}
                clientTypeId={clientTypeId}
                handleClientTypeChange={handleClientTypeChange}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({
  table_data,
  exportToExcel,
  clientTypes,
  clientTypeId,
  handleClientTypeChange,
}) => {
  const { checkAccess } = usePermissionData()
  const module_id = 28
  const navigate = useNavigate()

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "employeeId",
        filterable: true,
        disableFilters: true,
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Employee",
        accessor: "employeeName",
        disableFilters: true,
        filterable: true,
        className: "col-2",
        Cell: cellProps => {
          return (
            <div className="d-flex align-items-center">
              <div className="text-center employee-margin-right">
                <img
                  src={
                    cellProps.row.original?.employeePhoto
                      ? `${process.env.REACT_APP_IMAGE_PATH}/${cellProps.row.original?.employeePhoto}`
                      : practice_logo
                  }
                  alt="img"
                  className="rounded-circle"
                  width={35}
                  height={35}
                />
              </div>
              <div>{cellProps.row.original?.employeeName}</div>
            </div>
          )
        },
      },
      {
        Header: "Client Manager",
        accessor: "clientManager",
        disableFilters: true,
        filterable: true,
        className: " text-center",
      },
      {
        Header: "Production Manager",
        accessor: "productionManager",
        disableFilters: true,
        className: " text-center",
      },
      {
        Header: "Assistant",
        accessor: "assistant",
        disableFilters: true,
        className: " text-center",
      },
      {
        Header: "Administrator",
        accessor: "administrator",
        disableFilters: true,
        className: "text-center",
      },
    ],
    [table_data]
  )

  const data = useMemo(() => {
    return table_data
  }, [table_data])

  return (
    <PermittedComponent isAccess={checkAccess(module_id, "view")}>
      <CommonTable
        columns={columns}
        data={data}
        heading={
          <>
            <div>{`Employee Designation Report`}</div>
          </>
        }
      >
        <div className="d-flex">
          <div className="ms-3">
            <select
              className="form-select"
              value={clientTypeId || ""}
              onChange={handleClientTypeChange}
            >
              <option value="">All Client Types</option>
              {clientTypes.map(type => (
                <option key={type.id} value={type.id}>
                  {type.clientType}
                </option>
              ))}
            </select>
          </div>
          <div>
            <button
              onClick={exportToExcel}
              className="btn btn-primary bg-primary ms-3"
            >
              <i className="fas fa-download me-3"></i>
              Export
            </button>
          </div>
          <div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </div>
      </CommonTable>
    </PermittedComponent>
  )
}

export default EmployeeDesignationReport
